import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ReleaseNotesIdsEnum, ReleaseNotesTitlesEnum } from '@shared/enums/corrections/dialogs/release-notes.enum';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReleaseNotesComponent {
  @Output() viewNow = new EventEmitter<void>();
  ids = ReleaseNotesIdsEnum;
  dialogTexts = ReleaseNotesTitlesEnum;

  constructor(public dialogRef: MatDialogRef<ReleaseNotesComponent>) {}

  viewReleaseNotes(): void {
    this.close();
    this.viewNow.emit();
  }

  close(): void {
    this.dialogRef.close();
  }
}
